<template>
	<div class="form-field">
		<label :for="name">
			{{ label }}
			<span v-if="subtitle">{{ subtitle }}</span>
		</label>
		<select :value="modelValue" :id="name" :name="name" v-model="selected">
			<option value="" v-if="placeholder || label" disabled>
				{{ placeholder ?? label }}
			</option>
			<option v-for="option in options" :value="option" :disabled="validOptions.indexOf(option) === -1">
				{{ option }}
			</option>
		</select>
	</div>
	<input-text v-model="customValue" v-if="selected === otherValue && otherValue" :label="otherLabel" name="other" />
</template>

<script>
import scrollLock from 'scroll-lock';
import InputText from './InputText.vue';

export default {
	name: 'SelectInput',
	components: { InputText },
	props: {
		'title': String,
		'label': String, 
		'name': String, 
		'options': Array, 
		'otherValue': String, 
		'otherLabel': String, 
		'modelValue': {
			type: String,
			default: ''
		},
		'placeholder': String, 
		'minValue': String,
		'subtitle': String,
	},
	data() {
		const isCustom = !!(this.options.indexOf(this.modelValue) === -1 && this.modelValue);
		return {
			selected: isCustom ? this.otherValue : this.modelValue,
			customValue: isCustom ? this.modelValue : '',
			showOverlay: false,
		};
	},
	computed: {
		isCustom() {
			return !!(this.selected === this.otherValue && this.otherValue);
		},
		value() {
			return this.isCustom ? this.customValue : this.selected;
		},
		validOptions() {
			if (!this.minValue) {
				return this.options;
			}
			return this.options.filter((x) => x >= this.minValue);
		},
		typeB() {
			return (window.testSettings || {})['select-type'] === 'B';
		},
	},
	methods: {
		selectOption(option) {
			this.selected = option;
			this.showOverlay = false;
		},
	},
	watch: {
		showOverlay() {
			if (this.showOverlay) {
				scrollLock.disablePageScroll(this.$refs.overlay);
			} else {
				scrollLock.enablePageScroll(this.$refs.overlay);
			}
		},
		value() {
			this.$emit('update:modelValue', this.value);
		},
		validOptions(validOptions) {
			if (this.selected && validOptions.indexOf(this.selected) == -1) {
				this.selected = validOptions[0];
			}
		},
	},
};
</script>

<style scoped>
select{
	display: inline-block !important;
	background-color: #fff;
	border: 1px solid #dadde2;
	border-radius: 7px;
	font-size: 1.6rem;
	padding: 21px 18px 19px;
	width: 100%;
	color: inherit;
	height: 60px;
}

option:disabled {
	opacity: 0.5;
}

.select {
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-radius: 7px;
	border: solid 1px #dadde2;
	padding: 21px 18px 19px;
	width: 100%;
	background: white;
}

.select--disabled {
	color: #6c7380;
}
.select-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	background: white;
	z-index: 10000;

	--title-height: 52px;
}

.select-overlay__title {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	height: var(--title-height);
	border-bottom: 1px solid #dadde2;
	padding: 0 5vw;
	font-size: 1.4rem;
	font-weight: bold;
}

.select-overlay__title svg {
	position: absolute;
	left: 5vw;
	top: 50%;
	transform: translateY(-50%);
}

.select-overlay__options {
	height: calc(100vh - var(--title-height));
	height: calc(100dvh - var(--title-height));
	overflow: auto;
	display: flex;
	flex-direction: column;
}

.option {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px 5vw 22px;
	background: transparent;
	font-size: 1.6rem;
	line-height: 1.25;
	border: 0;
	border-bottom: 1px solid #dadde2;
	text-align: left;
	cursor: pointer;
}

.option.disabled {
	opacity: 0.5;
	cursor: default;
	pointer-events: none;
}

.option__selected {
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	width: 24px;
	height: 24px;
	background-color: #da503b;
}
.option__selected .icon {
	width: 10px;
	height: 9px;
}
</style>
